/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_Q3_BInputs */

const en_consult_q3_b = /** @type {(inputs: Consult_Q3_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planning to start in 1–3 months`)
};

const id_consult_q3_b = /** @type {(inputs: Consult_Q3_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rencana mulai 1–3 bulan lagi`)
};

/**
* | output |
* | --- |
* | "Planning to start in 1–3 months" |
*
* @param {Consult_Q3_BInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_q3_b = /** @type {((inputs?: Consult_Q3_BInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_Q3_BInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_q3_b(inputs)
	return en_consult_q3_b(inputs)
});